import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Zone } from '@/core/api/entities/zone/zone'

interface ActiveZoneState {
	zone: Zone | null
	isLoading: boolean
	error: string | null
}

const initialState: ActiveZoneState = {
	zone: null,
	isLoading: false,
	error: null,
}

const activeZoneSlice = createSlice({
	name: 'activeZone',
	initialState,
	reducers: {
		setActiveZone: (state, action: PayloadAction<Zone>) => {
			state.zone = action.payload
			state.error = null
		},
		setActiveZoneLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		},
		setActiveZoneError: (state, action: PayloadAction<string>) => {
			state.error = action.payload
		},
		clearActiveZone: (state) => {
			state.zone = null
			state.error = null
		},
	},
})

export const {
	setActiveZone,
	setActiveZoneLoading,
	setActiveZoneError,
	clearActiveZone,
} = activeZoneSlice.actions

export default activeZoneSlice.reducer
